// NPM Imports
import React, { Component } from "react";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Modal from "react-responsive-modal";
import { Button } from "@revvsales/components";
import { connect } from "react-redux";

// Action Imports
import { updateVideoUrl } from "../../../actions/DocumentActions";

// import RecordVideo from "@revvsales/record-video";
import RecordVideoComponent from "./RecordVideoComponent";

import { documentAttachmentService } from "../../../actions/DocumentActions/services";
// import dummyVideo from "../../../assets/screenRecording.mp4";

// Components Imports

class RecordVideoPopupSender extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // isRecording: false,
      // isRecorded: false,
      showShareBtnLoader: false,
      uploadVideoFile: "",
      // thumbnailFile: "",
      videoThumbnail: "",
      currentVideoUrl: "",
    };
  }

  componentDidMount() {
    this.setState({ currentVideoUrl: this.props.videoKycUrl });
  }

  _closePopup = () => {
    this.props.updateMultipleState({
      showEmailMessage: false,
      toggleRecordVideoPopup: false,
    });
  };

  _updateState = obj => {
    // console.debug("in popup ", obj);
    this.setState({
      ...obj,
    });
  };

  _resetAttachVideo = () => {
    this.setState({
      uploadVideoFile: "",
      videoThumbnail: "",
      currentVideoUrl: "",
    });
    this.props.updateVideoUrl(this.state.currentVideoUrl);
  };

  _attachVideo = () => {
    this.setState({ showShareBtnLoader: true });
    this.props.updateVideoUrl(this.state.currentVideoUrl);
    documentAttachmentService(
      this.props.docID,
      this.state.uploadVideoFile,
      this.state.videoThumbnail,
      this.props.sharingHash,
    )
      .then(res => {
        this.props.updateMultipleState({
          addAcceptorList: true,
          toggleRecordVideoPopup: false,
          attachmentID: res.Attachment.ID,
          videoThumbnail: res.Attachment.ThumbnailLink,
        });
      })
      .catch(() => {
        this.setState({
          showShareBtnLoader: false,
        });
      });
    this.props.updateMultipleState({
      addAcceptorList: true,
      toggleRecordVideoPopup: false,
    });
  };

  _renderModalFooter = () => {
    if (this.state.uploadVideoFile || this.state.currentVideoUrl) {
      return (
        <div className="modal-footer">
          <Button
            isLoading={this.state.showShareBtnLoader}
            id="recordvideo-back-btn"
            className="btn btn-transparent modal-footer-btn submit-btn"
            data-test="recordvideo-back-btn"
            onClick={this._resetAttachVideo}>
            Discard and re-record
          </Button>
          <Button
            isLoading={this.state.showShareBtnLoader}
            id="recordvideo-close-btn"
            className="btn btn-primary modal-footer-btn submit-btn"
            data-test="recordvideo-close-btn"
            onClick={this._attachVideo}>
            Attach video
          </Button>
        </div>
      );
    }
    return null;
  };

  render() {
    return (
      <Modal
        open
        onClose={this._closePopup}
        center
        closeOnOverlayClick={false}
        classNames={{
          modal: "custom-modal-recordvideo",
        }}>
        <div className="recordvideopopup-container">
          {/* ----------- Modal Heading Section ----------- */}
          <div
            className="modal-heading"
            data-test="recordvideo-modal-heading-sender">
            Start recording
          </div>
          <div className="recordvideo-popup-content-section">
            <div className="recordvideo-popup-info-list">
              {`Use your video to introduce yourself, summarize your document and
              request their recipients' consent on it.`}
            </div>
            <div className="recordvideo-popup-info-list">
              <RecordVideoComponent
                docID={this.props.docID}
                sharingHash={this.props.sharingHash}
                updateState={this._updateState}
                videoFileAvailable={this.state.uploadVideoFile}
                fileName={this.props.createdBy.name}
                currentVideoUrl={this.state.currentVideoUrl}
              />
            </div>
          </div>
          {/* ----------- Modal Footer Section ----------- */}
          {this._renderModalFooter()}
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  const {
    document: { id: docID, created_by: createdBy },
    videoKycUrl,
  } = state.DocumentStore;
  return {
    docID,
    createdBy,
    videoKycUrl,
  };
};

const mapDispatchToProps = {
  updateVideoUrl,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(RecordVideoPopupSender);



// WEBPACK FOOTER //
// ./src/components/DocumentApprovalPopupNew/RecordVideoPopup/RecordVideoPopupSender.js